module.exports = __webpack_public_path__ + "static/media/p208panel.01cc0fd3.jpg";